<template>
  <div id="app">
    <HomeComp v-if="loadFlag"/>
    <p>ICP证：浙B2-20220316 网站备案：浙ICP备19014071号-1   浙网文 【2016】5750-326号</p>
    <p> APP备案：浙ICP备18015926号-31A 浙公网安备33021202003585号</p>
  </div>
</template>

<script>
import HomeComp from './components/HomeComp.vue'
import dataCenter from './js/DataCenter';
// import {getUrl3d} from './js/http/request'
export default {
  name: 'App',
  components: {
    HomeComp
  },
  data(){
    return {
      loadFlag:false
    }
  },
  mounted(){
    let _this = this;
    // getUrl3d().then(()=>{})
    _this.loadFlag = true
    dataCenter.uploadStatistics(10000)
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
}
body {
  background: #072A57;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #fff;
}
</style>
